import dayjs from 'dayjs';
import _ from 'lodash';

export const Formatter = {
    defaultDateTimeFormat: 'YYYY-MM-DD HH:mm:ss',
    defaultDatepickerPreviewFormat: 'yyyy-MM-dd',
    standardDateFormat: 'YYYY-MM-DD',

    convertDateFromInputToUtcDateStr(dateInput: any): string {
        return Formatter.convertToUtcDateStr(dateInput, {
            hour: 0,
            minute: 0,
            second: 0
        });
    },

    convertDateToInputToUtcDateStr(dateInput: any): string {
        return Formatter.convertToUtcDateStr(dateInput, {
            hour: 23,
            minute: 59,
            second: 59
        });
    },

    convertToUtcDateStr(dateInput: any, params: any): string {
        if (dateInput === null || dateInput === undefined || dateInput === '') {
            return '';
        }
        const local = dayjs(dateInput);
        if (!local.isValid()) {
            return '';
        }
        const dateOnly = local.format(Formatter.standardDateFormat);
        const hour = String(params.hour).padStart(2, '0');
        const minute = String(params.minute).padStart(2, '0');
        const second = String(params.second).padStart(2, '0');
        return `${dateOnly}T${hour}:${minute}:${second}.000Z`;
    },

    convertDateToStandardFormatDateStr(dateInput: any): string {
        if (dateInput === null || dateInput === undefined || dateInput === '') {
            return '';
        }
        const dt = dayjs(dateInput);
        if (dt.isValid()) {
            return dt.format(Formatter.standardDateFormat);
        }
        return '';
    },

    lowerCaseFormatter(str: string): string {
        if (str) {
            return str.toLowerCase();
        }
        return '';
    },

    upperCaseFormatter(str: string): string {
        if (str) {
            return str.toUpperCase();
        }
        return '';
    },

    ddlDescFormatter(code: any, list: any[]): string {
        const opt = _.find(list, { code: code });
        if (opt) {
            return _.get(opt, 'desc');
        }
        return code;
    },

    prependSearchDdl(ddlList: Object[]): Object[] {
        ddlList.unshift({
            desc: 'All',
            code: ''
        });
        return ddlList;
    },

    formatTimeToDefault: function (iso8601Time: string) {
        if (iso8601Time === null || iso8601Time === undefined || iso8601Time === '') {
            return '';
        }
        const dt = dayjs(iso8601Time);
        if (dt.isValid()) {
            return dt.format(Formatter.defaultDateTimeFormat);
        }
        return '';
    }
};
